

































































































































































import { ObjectFactory } from '@/config/objectFactory';
import { LatLng, ServiceRequestStatistics } from '@/types/response';
import { Component, Vue } from 'vue-property-decorator';
import GoogleMap from '../components/GoogleMap.vue';

@Component({
    components: {
       GoogleMap,
    },
})
export default class Dashboard extends Vue {
    private transportersLocation: LatLng[] = [];
    private interpretersLocation: LatLng[] = [];
    private serviceStatistics: ServiceRequestStatistics = {};
    private mounted() {
        this.init();
    }
    private async init() {
        await this.getRequestStatistics();
        await this.getPartnersLocation();
    }
    private async getPartnersLocation() {
        const response = await ObjectFactory.getTransporterService()
                .getPartnersLocation(this.$store.state.serverUrl);
        if (response.data) {
            this.transportersLocation = response.data.transportersLocation;
            this.interpretersLocation = response.data.interpretersLocation;
        }
    }
    private async getRequestStatistics() {
        const response = await ObjectFactory.getRequestService()
                .getRequestStatistics(this.$store.state.serverUrl);
        if (response.data) {
            this.serviceStatistics = response.data;
        }
    }
}
